import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation,Trans  } from 'react-i18next';
const Connect = () => {
     const { t } = useTranslation();
    return (
        <>
            <section className='lyt-section typ-connect-sec'  id='connectgrsf'>
                <div className='container'>
                    <div className='bs-grid-box typ-two-grid typ45gap align-items-center'>
                        <div className='leftBox' data-aos="fade-in" data-aos-delay="200">
                            <div className='img-box'>
                                <img
                                    className="img-fluid"
                                    src="/images/home/connect/main-img.jpg"
                                    alt="logo"
                                    width={541}
                                    height={584}
                                />
                            </div>
                        </div>
                        <div className='rightBox' data-aos="fade-in" data-aos-delay="200">
                            <div>
                                <div className='heading-wrapper'>
                                    <div>
                                        <h2 className='bs-heading typdblue mb-2'>{t('connectTitle')}</h2>
                                        <p className='bs-para typblue'>{t('connectDesc')}</p>
                                    </div>
                                </div>
                                <div>
                                    <Link className="bs-btn typfill" to="/contact-us" aria-label="Navigate to Contact Us page">
                                        {t('getInTouch')} <span className="icon icon-right-arrow"></span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Connect;
